module.exports = __webpack_public_path__ + "img/company14.5a5a828e.png";